import gql from 'graphql-tag';

const mutationPatchMainDisplayObjectsInfo = gql`
  mutation patchMainDisplayObjectsInfo(
    $conversationIDs: [DokkioID!]
    $dokkioTagIDs: [DokkioID!]
    $webpageIDs: [DokkioID!]
    $dokkioThreadIDs: [DokkioID!]
    $integrationItemIDs: [IntegrationItemInput!]
    $dokkioTagIDsToAdd: [DokkioID!]
    $dokkioTagIDsToRemove: [DokkioID!]
    $recursive: Boolean
  ) {
    patchMainDisplayObjectsInfo(
      conversationIDs: $conversationIDs
      dokkioTagIDs: $dokkioTagIDs
      webpageIDs: $webpageIDs
      dokkioThreadIDs: $dokkioThreadIDs
      integrationItemIDs: $integrationItemIDs
      dokkioTagIDsToAdd: $dokkioTagIDsToAdd
      dokkioTagIDsToRemove: $dokkioTagIDsToRemove
      recursive: $recursive
    )
  }
`;

export default mutationPatchMainDisplayObjectsInfo;
